import axios from 'axios'
import { redirect } from '../utils/redirect'
axios.defaults.withCredentials = true
axios.defaults.baseURL = process.env.VUE_APP_API_URL
export default {
  namespaced: true,
  state: {
    authUser: {},
    // isAuth: false, // Indica si existe un usuario autenticado
    forzadoCerrarSesion: false,
    isAdmin: false,
    isAdmon: false,
  },
  mutations: {
    SET_USER(state, user) {
      state.authUser = user
      if (Boolean(Object.keys(user).length)) {
        // Si el objeto pasado tiene contenido, devuelve true e indica que el usuario está autenticado
        state.authUser.isAdmin = state.authUser.grupos.some(grupo => grupo.id === 1)
        state.authUser.isAdmon = state.authUser.grupos.some(grupo => grupo.id === 4)
      }
    },
    SET_FORZARCERRARSESION(state, valor) {
      state.forzadoCerrarSesion = valor
    },
  },
  actions: {
    async getEstado({ commit }) {
      try {
        let respuesta = await axios.get('/api/user')
        commit('SET_USER', respuesta.data)
        if (!respuesta.data.two_factor && respuesta.data.enforce_mfa) {
          redirect('two-factor-enable')
        }
      } catch (error) {
        console.log('No autenticado')
      }
      // if(sessionStorage.getItem("isAuth") != null){
      //     let respuesta = await axios.get('/api/user');
      //     commit('SET_USER', respuesta.data);
      // }
    },
    setUser({ commit }, user) {
      commit('SET_USER', user)
    },
    setForzadoCerrarSesion({ commit }, valor) {
      commit('SET_FORZARCERRARSESION', valor)
    },
  },
  getters: {
    tienePermisosEnComponenteId: state => componenteId =>
      state.authUser.componentes.filter(componente => componente.componente_id === componenteId)[0].permiso_id > 1,
  },
}
